// IMPORT PACKAGE REFERENCES
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { EquipmentSection } from './EquipmentSection';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { removeEquipmentFromSegment, addEquipmentToSegment, getSegment } from '../../../state/actions/SegmentActions';
import { getEquipment, removeSegmentFromEquipment, addSegmentToEquipment } from '../../../state/actions/EquipmentActions';
import { Loading} from '../../../containers/Loading';
import { SegmentEquipmentModal } from '../../../modals/SegmentEquipmentModal';



// COMPONENT
class SegmentDetailsPage extends React.Component {

    constructor(props) {
        super(props);
        
        this.state = {
            segment: {},
            equipment: [],
            modal: false,
            segmentName: ''
        };

        this.toggleModal = this.toggleModal.bind(this);
        this.removeEquipment = this.removeEquipment.bind(this);
        this.addEquipmentToSegment = this.addEquipmentToSegment.bind(this);
        this.parseSegmentDetails = this.parseSegmentDetails.bind(this);
        this.updateEquipment = this.updateEquipment.bind(this);

    }

    parseSegmentDetails(searchString){
        let params = new URLSearchParams(searchString);
        this.setState({segmentName: params.get('name')});
    }

    componentDidMount(){
        this.parseSegmentDetails(this.props.location.search);
        this.props.getSegment(this.props.match.params.segmentId);
    }

    updateEquipment(){
        if (this.props.segment != {} && this.props.segment.equipment != null && this.props.segment.equipment != undefined) {
            this.props.getEquipment(Object.keys(this.props.segment.equipment));
        } 
    }

    componentDidUpdate(prevProps) {

        if (this.props.equipment != prevProps.equipment) {
            this.setState({ equipment: this.props.equipment });
        }

        if(this.props.segment != prevProps.segment) {
            this.setState({ segment: this.props.segment});
            this.updateEquipment();
        }

        if(this.props.removedEquipmentFromSegment == true && prevProps.removedEquipmentFromSegment == false) {
            this.updateEquipment();
        }
    }

    toggleModal() {
        this.setState({
            modal: !this.state.modal
        });
    }

    addEquipmentToSegment(equipmentIds){
        this.props.addSegmentToEquipment([this.state.segment.id], equipmentIds);
        this.props.addEquipmentToSegment([this.state.segment.id], equipmentIds);
        this.props.getSegment(this.state.segment.id);
    }

    removeEquipment(equipmentId){
        this.props.removeSegmentFromEquipment(this.state.segment.id, equipmentId);
        this.props.removeEquipmentFromSegment(this.state.segment.id, equipmentId);
    }

    render() {
        return (
            <Fragment>
                <div className="page-title">Segment: {this.state.segmentName}</div>

                {(this.props.fetchingSegment || this.props.fetchingEquipmentFromIds) &&
                    <Loading/>
                }

                {!this.props.fetchingSegment &&
                    <EquipmentSection deleteItem={this.removeEquipment} equipment={this.state.equipment} toggleModal={this.toggleModal}/>
                }

                <SegmentEquipmentModal isOpen={this.state.modal} toggleModal={this.toggleModal} assignedEquipment={this.state.equipment} addEquipment={this.addEquipmentToSegment}/> 
            </Fragment>
        );
    }
}

SegmentDetailsPage.propTypes = {
    getSegment: PropTypes.func.isRequired,
    segment: PropTypes.object.isRequired,
    equipment: PropTypes.array.isRequired,
    location: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    getEquipment: PropTypes.func.isRequired,
    removeSegmentFromEquipment: PropTypes.func.isRequired,
    removeEquipmentFromSegment: PropTypes.func.isRequired,
    addSegmentToEquipment: PropTypes.func.isRequired,
    addEquipmentToSegment: PropTypes.func.isRequired,
    fetchingSegment: PropTypes.bool.isRequired,
    fetchedSegment: PropTypes.bool.isRequired,
    failedSegment: PropTypes.bool.isRequired,
    fetchingEquipmentFromIds: PropTypes.bool.isRequired,
    fetchedEquipmentFromIds: PropTypes.bool.isRequired,
    failedEquipmentFromIds: PropTypes.bool.isRequired,
    addingEquipmentToSegment: PropTypes.bool.isRequired,
    addedEquipmentToSegment: PropTypes.bool.isRequired,
    removingEquipmentFromSegment: PropTypes.bool.isRequired,
    removedEquipmentFromSegment: PropTypes.bool.isRequired,
    addingSegmentToEquipment: PropTypes.bool.isRequired,
    addedSegmentToEquipment: PropTypes.bool.isRequired,
    addSegmentToEquipmentFailed: PropTypes.bool.isRequired,
    match: PropTypes.object.isRequired
};

// CONFIGURE REACT REDUX
const mapStateToProps = state => {
    const { segment, fetchingSegment, fetchedSegment, failedSegment, addingEquipmentToSegment, addedEquipmentToSegment, removingEquipmentFromSegment, removedEquipmentFromSegment } = state.segmentReducer;
    const { equipment, fetchingEquipmentFromIds, fetchedEquipmentFromIds, failedEquipmentFromIds, addingSegmentToEquipment, addedSegmentToEquipment, addSegmentToEquipmentFailed, removingSegmentFromEquipment, removedSegmentFromEquipment, removeSegmentFromEquipmentFailed } = state.equipmentReducer;
    return { segment, equipment, fetchingSegment, fetchedSegment, failedSegment, addingEquipmentToSegment, addedEquipmentToSegment, removingEquipmentFromSegment, 
        removedEquipmentFromSegment, fetchingEquipmentFromIds, fetchedEquipmentFromIds, failedEquipmentFromIds, addingSegmentToEquipment, addedSegmentToEquipment, 
        addSegmentToEquipmentFailed, removingSegmentFromEquipment, removedSegmentFromEquipment, removeSegmentFromEquipmentFailed  };
};

const mapDispatchToProps = dispatch => (
    bindActionCreators({ getSegment, getEquipment, removeSegmentFromEquipment, addSegmentToEquipment, addEquipmentToSegment, removeEquipmentFromSegment }, dispatch)
);
// CONFIGURE REACT REDUX

const hoc = withRouter(connect(mapStateToProps, mapDispatchToProps)(SegmentDetailsPage));

// EXPORT COMPONENT

export { hoc as SegmentDetailsPage };


// WEBPACK FOOTER //
// ./src/components/pages/Segments/Details/SegmentDetailsPage.js